export function getDomainFromEmailAddress(emailAddress: string): string | undefined {
    const atSignIndex = emailAddress.indexOf("@");
    
    if (atSignIndex !== -1 && atSignIndex !== emailAddress.length - 1) {
        return emailAddress.substring(atSignIndex + 1).toLowerCase();
    }
    
    return undefined;
}
